// removed by extract-text-webpack-plugin
module.exports = {"addressButtonShake":"_1BLdSxyZmrp1cguNl4FrCQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Places/AddressButton.css
// module id = 228
// module chunks = 0